const useCookie = (cookieName: string): any => {
    const getCookie = () => {
        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(cookieName));

        return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
    };

    const setCookie = (value: string, days: number) => {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "; expires=" + date.toUTCString();

        document.cookie = cookieName + "=" + encodeURIComponent(value) + expires + "; path=/";
    };

    return [getCookie, setCookie];
};

export default useCookie;